import apiFetch from '../apiFetch'

export default function (values, token)  {  
  return apiFetch({endPoint: `Analisis/insertAnalisisPIC`,method: 'POST', body: values, token: token})
}
